import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  homeSections = undefined;
  domainId = environment.domainId;
  paramSuscription = new Subscription();
  paramReload = new Subscription();

  constructor(
    private navCtrl: NavController,
    public paramSv: ParamServicesService
  ) {}

  async ngOnInit() {}

  goTo(url) {
    this.navCtrl.navigateForward(url);
  }
}
